import { FC } from 'react';
import InputLabel from 'raydiant-elements/core/InputLabel';
import InputHelperText from 'raydiant-elements/core/InputHelperText';
import Select from 'raydiant-elements/core/Select';
import Text from 'raydiant-elements/core/Text';
import {
  getPropertyDefault,
  setPropertyDefault,
} from '../../utilities/properties';
import { useApplicationFormContext } from '../../hooks/useApplicationForm';

interface ApplicationInputDefaultToggleProps {}

const ApplicationInputDefaultToggle: FC<ApplicationInputDefaultToggleProps> = () => {
  const {
    isEditable,
    version,
    selectedProperty,
    updateSelectedProperty,
  } = useApplicationFormContext();

  // Callbacks

  const handleChange = (defaultValue: string) => {
    if (!selectedProperty) return;
    if (!version) return;

    updateSelectedProperty(
      setPropertyDefault(selectedProperty, defaultValue === 'on'),
      version.strings,
    );
  };

  // Render

  const defaultValue =
    selectedProperty && getPropertyDefault(selectedProperty) === true
      ? 'on'
      : 'off';

  return (
    <div>
      <InputLabel>Initial Value</InputLabel>

      {isEditable && (
        <>
          <Select value={defaultValue} onChange={handleChange}>
            <option value="on">On</option>
            <option value="off">Off</option>
          </Select>
          <InputHelperText>The intial value of the input</InputHelperText>
        </>
      )}

      {!isEditable && selectedProperty && (
        <Text>{getPropertyDefault(selectedProperty) || <em>None</em>}</Text>
      )}
    </div>
  );
};

export default ApplicationInputDefaultToggle;
